import { InstalledApplication } from '@era/locations-sdk';

import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export function selectUniqueIdFromApplication(application: InstalledApplication) {
  return `${application.locationId}-${application.deviceId}-${application.bundleIdentifier}`;
}

export const adapter: EntityAdapter<InstalledApplication> = createEntityAdapter<InstalledApplication>({
  selectId: selectUniqueIdFromApplication,
});

export type InstalledApplicationsState = EntityState<InstalledApplication>;

export const initialState: InstalledApplicationsState = adapter.getInitialState();
